import { EmptyState, EmptyStateIllustrationImage } from 'components/EmptyState'
import { observer } from 'mobx-react'
import React from 'react'
import OCRScopeNewJobButton from '../../../../OCRScopeNewJobButton'
import CreateOCRScopeJobsViewModel from '../../../../../views/CreateOCRScopeJobsDialog/CreateOCRScopeJobsViewModel'

interface OCRScopeJobEmptyStateProps {
  vm: CreateOCRScopeJobsViewModel
}

export default observer(function OCRScopeJobUnselected({
  vm,
}: OCRScopeJobEmptyStateProps) {
  return (
    <EmptyState
      image={
        <EmptyStateIllustrationImage
          src={require('assets/images/img_drag-drop.svg')}
        />
      }
      title="Drag and drop to scope new jobs"
      subtitle="Upload one or more files here. Acceptable file types include: BMP, JPEG, JPG, PDF, PNG, TIF, TIFF, WEBP"
      animate
      small
    >
      <OCRScopeNewJobButton vm={vm} />
    </EmptyState>
  )
})
